import { InterfaceIcon } from '@helpers/icons';
import SvgBRC from '@img/logos/brc-purple.svg';
import SvgNIRC from '@img/logos/nirc-purple.svg';
import SvgSRC from '@img/logos/src-purple.svg';
import SvgWRC from '@img/logos/wrc-purple.svg';
import Button, { LinkButton } from '@stories/Components/Buttons/Button/Button';
import Searchbox from '@stories/Components/Misc/Searchbox/Searchbox';
import * as React from 'react';
import AccountDropdown from './AccountDropdown/AccountDropdown';
import AnnouncementBar from './AnnouncementBar/AnnouncementBar';
import S from './Header.styles';
import Navigation from './Navigation/Navigation';
export var Site;
(function (Site) {
    Site["BRC"] = "brc";
    Site["NIRC"] = "nirc";
    Site["SRC"] = "src";
    Site["WRC"] = "wrc";
})(Site || (Site = {}));
const Header = (props) => {
    const [active, setActive] = React.useState(-1);
    const [menuOpen, setMenuOpen] = React.useState(false);
    const [searchOpen, setSearchOpen] = React.useState(false);
    return (React.createElement(S.Container, null,
        React.createElement(S.GlobalStyles, null),
        React.createElement(AnnouncementBar, { ...props }),
        React.createElement(S.Header, { onMouseLeave: () => setActive(-1) },
            React.createElement(S.Logo, { href: props.site.url, "aria-label": props.site.label, onMouseEnter: () => setActive(-1) }, renderLogo(props.site.type)),
            React.createElement(Navigation, { active: menuOpen, contactCta: props.contactCta, links: props.links, regionSelector: props.regionSelector, signUpCta: !props.accountDropdown ? props.signUpCta : undefined, translations: props.translations, activeLink: active, setActiveLink: setActive }),
            React.createElement(S.CtaWrapper, { onMouseEnter: () => setActive(-1) },
                React.createElement(Button, { buttonType: "secondary", onClick: () => {
                        setSearchOpen(!searchOpen);
                        setMenuOpen(false);
                    }, icon: !searchOpen ? InterfaceIcon.Search : InterfaceIcon.Close, "data-mobile-only": true }, !searchOpen ? (React.createElement(React.Fragment, null, props.translations?.['global.search.open'] ?? '')) : (React.createElement(React.Fragment, null, props.translations?.['global.search.close'] ?? ''))),
                React.createElement(S.SearchboxContainer, { "data-open": searchOpen },
                    React.createElement(S.SearchBoxInner, null,
                        React.createElement(Searchbox, { ...props.searchbox, idPrefix: "header-" }))),
                React.createElement(S.SearchBackground, { "data-active": searchOpen }),
                props.accountDropdown ? (React.createElement(AccountDropdown, { ...props.accountDropdown, onClick: () => {
                        setSearchOpen(false);
                        setMenuOpen(false);
                    } })) : props.signInCta || props.signUpCta ? (React.createElement(React.Fragment, null,
                    props.signInCta && (React.createElement(LinkButton, { buttonType: props.signInCta.buttonType ? props.signInCta.buttonType : 'secondary', href: props.signInCta.url, target: props.signInCta.target, icon: props.signInCta.icon ?? InterfaceIcon.User }, props.signInCta.text)),
                    props.signUpCta && (React.createElement(LinkButton, { buttonType: props.signUpCta.buttonType ? props.signUpCta.buttonType : 'primary', href: props.signUpCta.url, target: props.signUpCta.target, icon: props.signUpCta.icon }, props.signUpCta.text)))) : null,
                React.createElement(Button, { buttonType: "secondary", onClick: () => {
                        if (!menuOpen) {
                            document.getElementById('nav-first-link')?.focus();
                        }
                        setMenuOpen(!menuOpen);
                        setSearchOpen(false);
                    }, icon: !menuOpen ? InterfaceIcon.Menu : InterfaceIcon.Close, "aria-controls": "main-nav", "aria-expanded": menuOpen, "data-mobile-only": true }, !menuOpen ? (React.createElement(React.Fragment, null, props.translations?.['global.menu.open'] ?? '')) : (React.createElement(React.Fragment, null, props.translations?.['global.menu.close'] ?? '')))))));
};
export function renderLogo(site) {
    switch (site) {
        case Site.BRC:
            return React.createElement(SvgBRC, null);
        case Site.NIRC:
            return React.createElement(SvgNIRC, null);
        case Site.SRC:
            return React.createElement(SvgSRC, null);
        case Site.WRC:
            return React.createElement(SvgWRC, null);
    }
}
export default Header;
